import styled from 'styled-components'
import { COLORS } from '@styles/colors'
import { textSM } from '@styles/fonts'
import { DEVICES } from '@constants/global'

export const RadioLabel = styled.span`
  position: relative;
  display: block;
  padding-left: 32px;

  &:before {
    content: '';
    background-color: transparent;
    border: 1px solid ${COLORS.secondary};
    border-radius: 100%;
    padding: 8px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    vertical-align: middle;
    cursor: pointer;
    margin-right: 5px;
  }

  @media ${DEVICES.mobile} {
    ${textSM};
  }
`

export const Radio = styled.label`
  display: inline-block;
  margin-right: 32px;
  cursor: pointer;

  input {
    padding: 0;
    height: initial;
    width: initial;
    margin-bottom: 0;
    display: none;
    cursor: pointer;
  }

  input:checked + ${RadioLabel}:after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 5px;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${COLORS.secondary};
  }
`
